import { socketService } from './socket';
import { AgentUser } from '../types';

class UserService {
  private userListCache: AgentUser[] = [];
  private lastFetch: number = 0;
  private cacheTimeout = 5 * 60 * 1000; // 5 minutes

  async getUserList(forceRefresh = false): Promise<AgentUser[]> {
    const now = Date.now();
    
    // Return cached data if it's fresh and not forcing refresh
    if (!forceRefresh && this.userListCache.length > 0 && (now - this.lastFetch) < this.cacheTimeout) {
      return this.userListCache;
    }

    return new Promise((resolve, reject) => {
      const socket = socketService.getSocket();
      if (!socket?.connected) {
        reject(new Error('Not connected to server'));
        return;
      }

      socket.emit('getUserList', (response: { success: boolean; error?: string; users: AgentUser[] }) => {
        if (response.success) {
          this.userListCache = response.users;
          this.lastFetch = now;
          resolve(response.users);
        } else {
          reject(new Error(response.error || 'Failed to get user list'));
        }
      });
    });
  }

  async searchUsers(searchTerm: string): Promise<AgentUser[]> {
    return new Promise((resolve, reject) => {
      const socket = socketService.getSocket();
      if (!socket?.connected) {
        reject(new Error('Not connected to server'));
        return;
      }

      socket.emit('userSearch', searchTerm, (response: { success: boolean; error?: string; users: any[] }) => {
        if (response.success) {
          resolve(response.users);
        } else {
          reject(new Error(response.error || 'Failed to search users'));
        }
      });
    });
  }

  // Clear cache (useful on logout)
  clearCache() {
    this.userListCache = [];
    this.lastFetch = 0;
  }

  // Get cached users without network call
  getCachedUsers(): AgentUser[] {
    return this.userListCache;
  }
}

export const userService = new UserService();